module.exports = __webpack_public_path__ + "47ddf9333285ffbe8d7a6412cf3237e0.png";